// 阿塞拜疆----address
module.exports = {
  validate: {
    noEmail: "E-poçt boş ola bilməz, yenidən daxil edin",
    noPhone: "Telefon nömrəsi boş ola bilməz, yenidən daxil edin",
    errorReg:
      "Giriş uzunluğu 1-50 rəqəmdir, siz böyük və kiçik hərflər, rəqəmlər, simvollar daxil edə bilərsiniz - . _ @",
    noPassword: "Parol boş ola bilməz, yenidən daxil edin",
    pwdReg:
      "Parolun daxil edilməsi uzunluğu 8-32 rəqəmdir, yalnız rəqəmlər və hərflərdən ibarət olmalıdır",
    pwdCheck: "Daxil edilmiş iki parol uyğun deyil, yenidən daxil edin",
    pwdLengthReg:
      "Şifrə uzunluğu 8 ilə 32 arasında dəyişir, lütfən daxil etməyi təsdiqləyin",
    noCode: "doğrulama kodunu daxil edin",
    codeReg: "6 rəqəmli doğrulama kodunu daxil edin",
    nullText: "Giriş boş ola bilməz, lütfən, yenidən daxil edin",
    phoneCheck:
      "İki dəfə daxil edilən telefon nömrəsi uyğun deyil, yenidən daxil edin",
    emailNumReg: "E-poçt daxiletmə uzunluğu 6-50 simvoldur, yenidən daxil edin",
    emailReg: "Yanlış e-poçt ünvanı, yenidən daxil edin",
    emailCheck:
      "İki dəfə daxil edilmiş e-poçt hesabı uyğun deyil, yenidən daxil edin",
    noUsername: "Parolda hesab nömrəsi ola bilməz, yenidən daxil edin",
    accountReg: "Hesab adının daxil edilməsi səhvdir, yenidən daxil edin",
  },
  area: {
    areaTitle: "Ərazi İdarəetmə",
    add: "Sahə əlavə et",
    area: "sahə",
    addNextArea: "Yeni tabelik sahəsi yaradın",
    areaNameTip: "Zəhmət olmasa bölgə adını daxil edin",
    areaNameHold:
      "Giriş uzunluğu 1-20 rəqəmdir, heç bir xüsusi simvol daxil edilə bilməz",
    areaNumHold:
      "Giriş uzunluğu 1-4 rəqəmdir, yalnız nömrələr daxil edilə bilər və nömrə diapazonu 0-9999-dur",
    areaNumTip: "Zəhmət olmasa sahə nömrəsini daxil edin",
    areaName: "Sahə adı",
    checkAreaName: "Sahə adı boş ola bilməz, yenidən daxil edin",
    areaNameTip1: "Sahə adı boş ola bilməz",
    areaNameTip2: "Yanlış sahə adı daxil edildi, yenidən daxil edin",
    areaNum: "Sahə nömrəsi",
    checkAreaNum: "Sahə ID-si boş ola bilməz, yenidən daxil edin",
    lastLevel: "Üstün sahəyə aiddir",
    checkLastLevel:
      "Aid olduğu yuxarı səviyyəli sahə boş ola bilməz, lütfən, yenidən seçin",
    lastLevelTip: "Lütfən, aid olduğunuz ana ərazini seçin",
    delInfo:
      "Bu silmə tapşırığını yerinə yetirmək bu sahədəki məlumatları siləcək və bərpa edilə bilməz",
    oneStep: "birinci səviyyə",
    twoStep: "orta",
    threeStep: "Səviyyə 3",
    fourStep: "Səviyyə 4",
    fiveStep: "5-ci səviyyə",
    delAreaTip: "Tabeliyində olan sahə var, onu silmək mümkün deyil",
    personArea: "Şəxs əraziyə bağlı deyil",
    areaType: "Metodu əlavə et",
    addArea1: "Ayrıca əlavə et",
    addArea2: "davamlı əlavə",
    addArea3: "Matrix əlavəsi",
    areaNameTop: "Zona adı prefiksi",
    areaNameLast: "Zona adı şəkilçisi",
    areaJoinHold: "Lütfən, domen adı prefiksini daxil edin",
    areaJoinHold1: "Zəhmət olmasa ərazi adı şəkilçisini daxil edin",
    startNum: "Başlanğıc nömrəsi",
    checkStartNum: "İlkin nömrə daxil edilməsi səhvdir, yenidən daxil edin",
    checkStartNum1:
      "Başlanğıc nömrənin daxil edilməsi boş ola bilməz, lütfən, yenidən daxil edin",
    checkEndNum: "Son nömrənin daxil edilməsi səhvdir, yenidən daxil edin",
    checkEndNum1: "Son nömrə boş ola bilməz, yenidən daxil edin",
    endNum: "Son nömrə",
    topStart: "Başlıq başlanğıc nömrəsi",
    checkTopStart:
      "Birinci başlanğıc nömrənin daxil edilməsi səhvdir, lütfən, yenidən daxil edin",
    checkTopStart1:
      "İlk başlanğıc nömrənin daxil edilməsi boş ola bilməz, lütfən, yenidən daxil edin",
    topEnd: "Başlıq son nömrəsi",
    checkTopEnd: "Başlığın son nömrəsi yanlışdır, yenidən daxil edin",
    checkTopEnd1:
      "Birinci son nömrənin girişi boş ola bilməz, yenidən daxil edin",
    lastStart: "Quyruq başlanğıc nömrəsi",
    checkLastStart:
      "Quyruq başlanğıc nömrəsinin daxil edilməsi səhvdir, yenidən daxil edin",
    checkLastStart1:
      "Başlanğıc nömrəsini daxil edin, boş ola bilməz, yenidən daxil edin",
    lastEnd: "Yol sonu nömrəsi",
    checkLastEnd:
      "Quyruğun son nömrəsini yanlış daxil edin, yenidən daxil edin",
    checkLastEnd1:
      "Quyruq sonu nömrəsinin daxil edilməsi boş ola bilməz, lütfən, yenidən daxil edin",
    topTip:
      "Giriş uzunluğu 1-2 rəqəmdir, yalnız nömrələr daxil edilə bilər və nömrə diapazonu 1-99-dür",
    lastTip:
      "Giriş uzunluğu 1-2 rəqəmdir, yalnız rəqəmlər daxil edilə bilər və nömrə diapazonu 1-99-dir",
    areaNameTest: "Ərazi adı nümunəsi",
  },
  addressBook: {
    config: "Layihənin konfiqurasiyası",
    errorTip: "Ünvan kitabının formatı xətası",
    upgrade: "Ünvan Kitabının Təkmilləşdirilməsi İdarəetməsi",
    deviceIdTip: "Cihaz ID-ni daxil edin",
    deviceId: "Cihaz ID",
    syncAll: "Hamısını sinxronlaşdırın",
    sync: "Sinxronizasiya",
    sysVersion: "Cari Sistem Ünvan Kitabı Versiya",
    deviceVersion: "Cihazın ünvan kitabının cari versiyası",
    syncTip: "Sinxron əmr uğurla verildi",
  },
  newarea: {
    add: "Sahə əlavə et",
    edit: "Sahəni redaktə et",
    smallTip:
      "Hazırda ən kiçik sahə səviyyəsidir, başqa alt sahələr əlavə edilə bilməz",
    batch: "Toplu əlavə sahəsi",
    batch1: "davamlı əlavə",
    batch2: "Matrix əlavəsi",
  },
  deviceSip: {
    saveTip:
      "Ünvan kitabını vaxtında ixrac edin, əks halda səhifədən çıxdıqdan sonra bütün məlumatlar silinəcək.",
    devMsg: "Cihaz məlumatı",
    list: "Cihazların siyahısı",
    add: "Cihaz əlavə et",
    edit: "Cihazı redaktə et",
    batch: "Cihazları qrup halında əlavə edin",
    areaChosen: "Sahə səviyyəsinin seçimi",
    areaNum: "Hər sahədə yeni əlavə edilmiş cihazların sayı",
    bacthTip:
      "Sahə səviyyəsi bina kimi seçildikdə və hər bir ərazidə yeni cihazların sayı 4 olduqda, bu, hər bir yaradılan əraziyə 4 qurğunun əlavə olunması deməkdir",
    note: "təsvir etmək",
    baseConfig: "Əsas məlumat konfiqurasiyası",
    deviceName: "Cihaz adı",
    nameTip:
      "Mənsub olduğu qrupun adına nömrə əlavə etmək üçün düzəldildi, məsələn, Bina 1-1",
    function: "Cihaz dəstəyi funksiyası",
    net: "Şəbəkə Konfiqurasiyası",
    netType: "Şəbəkə növü",
    netTip1:
      "Statik statik şəbəkədir, IP və digər məlumatları əl ilə təyin etməlisiniz.",
    netTip2:
      "DHCP dinamik şəbəkədir və IP kimi məlumatlar avtomatik olaraq marşrutlaşdırıcı tərəfindən təyin edilir.",
    mask: "Alt şəbəkə maskasını daxil edin",
    gateway: "Lütfən, qapıya daxil olun",
    ip: "Zəhmət olmasa IP ünvanını daxil edin",
    ipTip: "Giriş IP ünvanı xüsusi IP-dən qaçmalıdır, məsələn, 127.0.0.1 və s.",
    dns1: "DNS1 daxil edin",
    dns2: "DNS2 daxil edin",
    sip1: "sip1 məlumat konfiqurasiyası",
    config: "Məlumat konfiqurasiyası",
    mode: "model",
    mode1: "Birbaşa rejim",
    mode2: "Server rejimi",
    user: "istifadəçi adını daxil edin",
    userTitle: "istifadəçi adı",
    userTip: "Defolt olaraq qrup adına nömrə əlavə etməkdir, məsələn, 1-1-1",
    last: "Zəhmət olmasa hesab şəkilçisini daxil edin",
    sipTip:
      "SIP serverinin qeydiyyatdan keçmiş istifadəçi adı və parolunu daxil edin",
    password: "Şifrənizi daxil edin",
    passwordTitle: "parol",
    serverIp: "Lütfən serverIP daxil edin",
    protocolType: "Lütfən, protokol növünü seçin",
    protocolTypeTitle: "müqavilə növü",
    sip2: "sip2 məlumat konfiqurasiyası",
    more: "Daha çox",
    close: "bağlama",
    formatError: "Format xətası, yenidən daxil edin",
    forbidTip: "127.0.0.1-ə daxil olmaq qadağandır, yenidən daxil edin",
    call: "Zəng edin və zəng edin",
    monitor: "ekran",
    lift: "Liftə Nəzarət",
    rtsp: "rtsp video axını",
    deviceTip: "Cihaz dəstəyi funksiyası boş ola bilməz, yenidən seçin",
    maskTip1: "Alt şəbəkə maskası boş ola bilməz, yenidən daxil edin",
    maskTip2: "Alt şəbəkə maskasının formatı səhvdir, yenidən daxil edin",
    gatewayTip1: "Gateway boş ola bilməz, lütfən, yenidən daxil olun",
    gatewayTip2: "Gateway format xətası, yenidən daxil edin",
    ipTip1: "IP ünvanı boş ola bilməz, yenidən daxil edin",
    ipTip2:
      "IP ünvanı formatında xəta, yuxarı hədd 255.254.254.253, birinci abzas 0 deyil, yenidən daxil edin",
    dns1Tip1: "DNS1 boş ola bilməz, yenidən daxil edin",
    dns1Tip2: "DNS1 format xətası, yenidən daxil edin",
    dns2Tip1: "DNS2 format xətası, yenidən daxil edin",
    passwordTip1: "Parol boş ola bilməz, yenidən daxil edin",
    serviceTip1: "serviceIp boş ola bilməz, yenidən daxil edin",
    serviceTip2: "serviceIp format xətası, yenidən daxil edin",
    sip2Tip:
      "Siz hazırda sip2 məlumatını konfiqurasiya etmisiniz, lütfən, onu qaydalara uyğun tamamlayın",
    devnameTip1: "Cihazın adı boş ola bilməz, yenidən daxil edin",
    devnameTip2: "Cihaz adı formatı xətası, yenidən daxil edin",
    nameTip1: "İstifadəçi adı boş ola bilməz, yenidən seçin",
    nameTip2: "İstifadəçi adı boş ola bilməz, yenidən seçin",
    maxTip1:
      "Cari sahədə cihazların sayı 8-in yuxarı həddinə çatıb və daha çox əlavə edilə bilməz",
    area: "sahə",
    editArea: "Sahəni redaktə et",
    addArea: "Sahə əlavə et",
    batchArea: "Toplu əlavə sahəsi",
    deleteArea: "Regionu sil",
    areaName: "Sahə adı",
    areaNo: "Sahə nömrəsi",
    importAddr: "İdxal Ünvan Kitabı",
    next: "Növbəti addım",
    areaTip1: "Lütfən, ilk olaraq redaktə ediləcək ərazini seçin",
    areaTip2: "Lütfən, əvvəlcə silinəcək ərazini seçin",
    areaTip3:
      "Cari əraziniz boşdur, siz hazırda cihazlarınızı qrup halında əlavə edə bilməzsiniz, lütfən, əvvəlcə ərazi məlumatını əlavə edin",
    noArea: "Hələ zona konfiqurasiyası yoxdur",
    error: "Məlumat istisnası",
    addDevice: "Cihaz əlavə et",
    editDevice: "Cihazı redaktə et",
    delDevice: "Cihazı silin",
    batchDevice: "Cihazları qrup halında əlavə edin",
    prev: "Əvvəlki",
    updateAddr: "Cihazın Ünvan Kitabını Yeniləyin",
    saveAddr: "Ünvan Kitabını Saxla",
    exportAddr: "İxrac Ünvan Kitabı",
    deleteTip: "Cihazın silinib-silinməyəcəyi",
    deleteTip2:
      "Hazırda region kimi seçilmişdir, silmək üçün bölgə konfiqurasiyasına qayıdın",
    deleteTip3: "Lütfən, əvvəlcə silinəcək cihazı seçin",
    deviceTip1: "Lütfən, ilk olaraq redaktə olunacaq cihazı seçin",
    deviceTip2: "Lütfən, əvvəlcə regionu seçin, sonra cihazı əlavə edin",
    exportSuccess: "İxrac uğurlu oldu",
    xmlTip: "Ünvan kitabının xml faylını yükləyin",
    xmlTip1: "Yükləmək üçün xml faylını seçin",
    xmlTip2:
      "İdxal edilmiş ünvan kitabçası mövcud icma səviyyəsinə uyğun gəlmir və idxal uğursuz oldu",
    areaConfig: "Sahə konfiqurasiyası",
    deviceConfig: "Cihazın konfiqurasiyası",
    exportConfig: "Önizləmə İxrac",
    projectConfig: "Layihənin konfiqurasiyası",
    prevArea: "Üstün sahəyə aiddir",
    areaNoTip:
      "Başlanğıc nömrəsi son nömrədən böyükdür, lütfən, yenidən doldurun",
    smallAreaTip:
      "Hazırda ən kiçik sahə səviyyəsidir, başqa alt sahələr əlavə edilə bilməz",
    areaNoTip1:
      "Birinci hissənin başlanğıc nömrəsi birinci hissənin son nömrəsindən böyükdür, lütfən, yenidən doldurun",
    areaNoTip2:
      "Quyruğun başlanğıc nömrəsi quyruğun son nömrəsindən böyükdür, lütfən, yenidən doldurun",
  },
  push: {
    list: "Push Record",
    productType: "Məhsul nömrəsi",
    softwareName: "proqramın adı",
    versionNo: "versiya nömrəsi",
    time: "İtək vaxtı",
    invalidTime: "Son istifadə müddəti",
    upgrade: "təkmilləşdirmə",
    upgradeRecord: "Yeniləmə qeydinə baxın",
    deviceType: "Avadanlıq növü",
    deviceName: "Cihaz adı",
    currentSoftName: "Cihazın proqram təminatının adı",
    currentSoftNo: "Cihazın cari versiya nömrəsi",
    upgradeNo: "Proqramın versiya nömrəsini təkmilləşdirin",
    filterTip1: "Cihazın adını daxil edin",
    filterTip2: "Zəhmət olmasa proqram adını seçin",
    filterTip3: "Lütfən, versiya nömrəsini seçin",
    checkTip: "Gənəni aktivləşdir",
    ota: "OTA yeniləməsi",
    taskName: "missiya adı",
    taskNameTip: "Lütfən, tapşırıq adını daxil edin",
    binName: "Firmware adı",
    upgradeType: "Tapşırıq təkmilləşdirmə metodu",
    done: "Dərhal edam edilsin",
    upgradeTime: "Yeniləmə vaxtı",
  },
  check: {
    submit: "Təbrik edirik, təqdimat uğurlu oldu!",
    noSubmit: "Oops, təqdim edilmədi!",
    file: "Sənəd seçin",
    noFile: "Heç bir fayl seçilməyib",
    projectName: "layihənin adı",
    projectNameTip: "Layihə adını daxil edin",
    describe: "təsvir etmək",
    contentTip: "Zəhmət olmasa məzmunu daxil edin",
    areaType: "Region iyerarxiyası",
    example: "Məsələn: bina-vahid-otaq nömrəsi",
    areaTip: "Sahə nömrəsi formatı səhvdir, yenidən daxil edin",
    areaNameTip: "Lütfən, təbəqə adını daxil edin",
    nameTip: "Ad boş ola bilməz, yenidən daxil edin",
    nameError: "Ad səhv daxil edilib, yenidən daxil edin",
    nameLength: "Ad girişinin uzunluğu 4~50-dir, yenidən daxil edin",
    areaNullTip: "Sahə səviyyəsi boş ola bilməz",
    formateError:
      "Uzunluq 1-6 rəqəmdir, heç bir xüsusi simvol daxil edilə bilməz",
    noAreaTip: "Sahə səviyyəsi boş ola bilməz, yenidən seçin",
    maxFileTip: "Fayl ölçüsü limiti aşır",
    xmlTip: "XML formatında fayl yükləyin",
  },
  book: {
    areaBy: "Region",
    list: "Cihaz məlumatlarının dublikat siyahısı",
    repeatTip:
      "Aşağıdakı avadanlıq məlumatı təkrarlanır. Lütfən, təkrarlanan avadanlıq məlumatını dəyişdirin.   Təsdiq et düyməsini kliklədikdən sonra o, avadanlığın daxilolma məlumatlarının təkrarlanmasını mühakimə edəcək. ",
    coverTip:
      "Bu əməliyyat hazırda seçilmiş səviyyənin məlumat əlavə edən toplusunun üzərinə yazacaq",
    batchTip: "Paketlərdə cihazları əlavə etməklə yaradılan IP diapazonu",
  },
  updateNewSip: {
    otaDeleteTip: "Silmək alınmadı, yalnız başlamamış tapşırıqlar silinə bilər",
    deleteArea1: "Bölgənin silinib-silinməyəcəyi",
    deleteArea2:
      "Eyni zamanda, bu sahədən aşağıda olan bütün sahələr və cihazlar birlikdə silinəcək",
    codeRepeatTip:
      "Eyni səviyyəli region ID-si təkrarlana bilməz, lütfən, cari region ID-ni yenidən daxil edin",
    nameRepeatTip:
      "Eyni səviyyədə olan ərazi adları təkrarlana bilməz, lütfən, cari bölgə adını yenidən daxil edin",
    deviceIp: "Cihaz IP",
    callin: "Zəng edin",
    callout: "nəfəs almaq",
    systemMsg: "sistem məlumatı",
    batchIpTip:
      "İP diapazonu bu dəfə qruplara cihazlar əlavə etməklə yaradılıb",
    ip: "IP ünvanı",
    mask: "Alt maska",
    gateway: "Gateway",
    noData: "Yox",
    noAddressTip:
      "Hazırda sinxronlaşdırıla bilən ünvan kitabçası məlumatları yoxdur",
    operator: "Operator",
    goTip: "Müvafiq addıma keçmək üçün klikləyin",
    deviceNameTip:
      "Giriş uzunluğu 1-16 rəqəmdir, heç bir xüsusi simvol daxil edilə bilməz",
    filter1: "Süzülmək üçün sahə adını daxil edin",
    filter2: "Süzülmək üçün ərazi adını və ya cihazın adını daxil edin",
    secret: "Şifrələmə parolu",
    secretTip: "32 simvoldan çox olmayan parol daxil edin, format məhdud deyil",
    noSecretTip: "Şifrələmə parolu təyin edilməyib",
    setSecret: "Ünvan kitabının şifrələmə parolunu təyin et",
    ignore: "laqeydlik",
    emptyBookTip:
      "Ünvan kitabçası boşdur və müvəqqəti olaraq ixrac edilə bilməz",
    errorSecret:
      "Ünvan kitabının şifrələməsi üçün parol xətası, yenidən daxil edin",
    other: "digər",
    doorAuth: "Giriş nəzarəti",
    funTitle:
      "Əlavə etdiyiniz cihaz tərəfindən dəstəklənən funksiyaları yoxlayın",
    callInTip: "Cihaz Dəstək Zəngi",
    callOutTip: "Cihaz dəstəyi adlanır",
    monitorTip: "Cihaz monitorinqi dəstəkləyir",
    doorTip: "Cihaz kilidin açılması funksiyasını dəstəkləyir",
    liftTip: "Cihaz dəstəyi idarəetmə lifti",
    maskTip:
      "Lütfən, alt şəbəkə maskasını daxil edin, format istinadı: 255.255.255.255",
    gatewayTip: "Lütfən, şlüz daxil edin, format istinadı: 1.1.1.1",
    ip1: "Zəhmət olmasa IP ünvanını daxil edin, format istinadı: 1.1.1.1",
    ipTip: "Giriş IP ünvanı xüsusi IP-dən qaçmalıdır, məsələn, 127.0.0.1 və s.",
    dns1: "Lütfən, DNS1 daxil edin, format istinadı: 1.1.1.1",
    dns2: "Lütfən, DNS2 daxil edin, format istinadı: 1.1.1.1",
    serverIp:
      "Lütfən serverIp daxil edin, istinad formatı: 1.1.1.1 və ya domen adı",
    successxml: "Fayl uğurla təhlil edildi",
    groupCall: "qrup zəngi",
    groupCallTip:
      "Aktiv olduqdan sonra qrup zəngi ikonasına klikləməklə qrupdakı bütün cihazlara zəng edə bilərsiniz",
    record: "versiya qeydi",
    export: "ixrac",
    sync: "Sinxronizasiya",
    communityTip:
      "Hazırda ərazidə cihaz məlumatları var, sahə səviyyəsini dəyişdirmək qadağandır",
    areaNameTitle: "İyerarxiya təsviri",
    noDataTip: "Hazırda məlumat yoxdur",
    areaCodeDescriptionTip:
      "Bölge tanımlaması boş deyil, lütfen onu tamamlayın",
    moduleName: "Ünvan Kitabı Qurğulama Aracı",
    userSipAccount:
      "Ana qrupunun alan nömrəsi kimi təyin edildi+equipment nömrəsi",
    devMax: "Aygıt düyünün 10000 sınırını aşır, əlavə edilməsi başarısız oldu",
    areaMax: "Bölge düyüm 10000 sınırını aşır, əlavə edilməsi başarısız oldu",
    ipAndMaskTip1:
      "IP ünvanı alt şəbəkə maskası ilə əlaqəlidir və iş məntiqinin təsdiqini keçməli və ya bitişik AND əməliyyatından sonra bütün 1 və ya bütün 0 nəticələri olmalıdır.",
    ipAndMaskTip2:
      "Bir iş təsdiq qaydası səhvi baş verərsə, müvafiq IP ünvanını dəyişdirin.",
    ipAndMaskTip3:
      "Alt şəbəkə maskası və IP ünvanının iş təsdiq qaydaları yanlışdır. IP ünvanını dəyişdirin.",
    ipAndMaskTip4:
      "Qurğular toplusu əlavə edilərkən, iş məntiqinin təsdiqini ötürməyən IP-lər avtomatik olaraq atlanacaq.",
    correctMaskTip:
      "Zəhmət olmasa əvvəlcə doğru alt şəbəkə maskəsini doldurun.",
    correctIpTip: "Zəhmət olmasa doğru IP ünvanını daxil edin.",
  },
  newDeviceType: {
    indoorMachine: "Daxili qurğuşun",
    doorPhone: "Qapı telefonu",
    smallDoor: "Kiçik qapı telefonu",
    manage: "İdarəetmə qurğusu",
    wall: "Divar qurğusu",
    monitor: "IP kamera",
    unitGuard: "Blok idarəetmə qurğusu",
    networkCard: "Şəbəkə kart oxucu",
    unitCard: "Blok kart oxucu",
    lift: "Asansörün əlaqəli modulu",
    deviceTypeTip: "Zəhmət olmasa, qurğunun növünü seçin",
  },
};
